export default __webpack_public_path__ + "static/media/building.c0dc2cce.png";